import API from "utils/API";

const GET_PEYK_REQUESTS = `/delivery/admin/courier-request`;
const CREATE_PEYK_REQUEST = `/delivery/admin/request-alopeyk/`;

export const GetDeliveryRange = (fields, params = {}) => {
  return API.get(
    `/delivery/admin/delivery_range/?fields=${fields.join(",")}/`,
    {
      params: params,
    }
  );
};

export const PostDeliveryRange = ({ body }) => {
  return API.post("/delivery/admin/delivery_range/", body);
};

export const PatchDeliveryRange = ({ body, id }) => {
  return API.patch(`/delivery/admin/delivery_range/${id}/`, body);
};

export const DeleteDeliveryRange = ({ id }) => {
  return API.delete(`/delivery/admin/delivery_range/${id}/`);
};

export const GetSingleDeliveryRange = (params) => {
  return API.get("/delivery/admin/delivery_range/", { params });
};

export const PostCreatePeykRequest = (body) => {
  return API.post(CREATE_PEYK_REQUEST, body);
};

export const GetSinglePeykRequest = (params) => {
  return API.get(GET_PEYK_REQUESTS, { params });
};

export const GetAllPeykRequest = (params) => {
  return API.get(GET_PEYK_REQUESTS, { params });
};

export const PostCancelSnappRequest = (pk) => {
  return API.post(`/delivery/admin/snapp-order/${pk}/cancel/`);
};